var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.535,
    height: 28.071,
    viewBox: "0 0 36.535 28.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#40b895;}.b{stroke:#4f4f4f;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.011)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 29.314,
    transform: "translate(0 12.367)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 29.314,
    transform: "translate(0 15.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M123.821,203.483H96.313a.9.9,0,0,1-.9-.9V186.5a.9.9,0,0,1,.9-.9h27.507a.9.9,0,0,1,.9.9v16.075A.9.9,0,0,1,123.821,203.483Z",
    transform: "translate(-95.41 -177.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M227.15,113.409l12.1-5.081a2.61,2.61,0,0,1,3.417,1.4l4.9,11.674a2.61,2.61,0,0,1-1.4,3.417l-1.441.606",
    transform: "translate(-213.246 -108.123)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 8.095,
    transform: "translate(3.277 22.649)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.071abb60437b5393c2364aed8aec96fa.svg";
export { ForwardRef as ReactComponent };